import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { calculateCustomerMetrics } from 'api/admin/businesses/businesses';
import { ApiError } from 'types/api';

interface UseCalculateMetricsPayload {
  businessCustomerIds?: number[];
  businessId: number;
}

export const useCalculateCustomerMetrics = () => {
  return useMutation<unknown, ApiError, UseCalculateMetricsPayload>({
    mutationFn: async ({ businessId, businessCustomerIds }) => {
      return calculateCustomerMetrics({ businessCustomerIds }, businessId);
    },
    onSuccess: async () => {
      toast.success('Metrics calculation initiated successfully!');
    },
    onError: (error) => {
      Sentry.captureException(error);
      toast.error(
        error?.response?.data?.error ?? 'An error occurred while initiating metrics calculation',
      );
      return error;
    },
  });
};
